import React from "react"
import {LinearProgress} from "@mui/material";
import {formatTime, str2arr} from "@/helper/method";
import {GridItem} from "@/widget/GridItem/GridItem";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import isEmpty from "lodash/isEmpty";
import {useQueryPlan} from "@/service/plan.s";
import Chip from "@mui/material/Chip";
import {Face} from '@mui/icons-material';
import {Grid, Typography} from "@mui/material";
import {useDrawerModal} from "@/store/global.c";

export const ViewPlan = () => {
    const {id} = useDrawerModal()
    const {data: planData, isLoading: planLoading} = useQueryPlan({id: id!})
    const plan = planData?.data
    const owners: string[] = str2arr(plan?.owners, 'string')

    return <ResultWrapper isLoading={planLoading} isEmpty={isEmpty(plan)}>
        <Grid
            spacing={3}
            container
        >
            <GridItem title={'目标名称'} content={plan?.planName}/>
            <GridItem title={'目标状态'} content={plan?.status}/>
            <GridItem title={'负责人'} content={plan?.executor}/>
            <GridItem title={'成员'}
                      content={owners?.map((owner: string, index: number) => <Chip key={index} sx={{mr: 0.4}} size={'small'} icon={<Face/>} label={owner}
                                                                                   variant="outlined"/>)}/>
            <GridItem title={'开始时间'} content={formatTime("h", plan?.startTime)}/>
            <GridItem title={'结束时间'} content={formatTime("h", plan?.endTime)}/>
            <GridItem title={'目标进度'} alignContent={'space-around'} minHeight={31}
                      content={<Grid container={true} direction={'row'} justifyContent={'space-between'} alignItems={'center'} alignContent={'center'}><Grid
                          size={10}><LinearProgress variant="determinate"
                                                    value={plan?.ratio}/></Grid><Typography>{plan?.ratio}%</Typography></Grid>}/>
            <GridItem title={'创建时间'} content={formatTime("h", plan?.createdAt)}/>
            <GridItem minHeight={'80px'} size={12} title={'目标说明'} content={plan?.description || '-'}/>
        </Grid>
    </ResultWrapper>
};
